<template lang="pug">
vm-row.gutters(vm-justify="flex-end", vm-align="center", vm-w=12)
  modal-testimonial-campaigns(:form="form" :isAdd="isAdd")
  vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      h3 {{ $t('strings.testimonials') }}
      vm-col.mb-3(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=12 vm-sm=12)
        vm-button(icon="plus" @click="addTestimonial") Agregar Testimonial
      vm-col.card(vm-sm=12)
        vm-table(v-model="selected"  max-height="350px" :data="testimonialCampaigns" )
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('testimonials.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'author'")  {{data[indextr][column]}}
                slot(v-if="column == 'text'")  {{data[indextr]['body'].substring(0, 25)}}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(data[indextr], tr)")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
const ModalTestimonialCampaigns = () => import('@/components/modals/ModalTestimonialCampaigns.vue')
const { mapGetters, mapActions } = createNamespacedHelpers('TestimonialCampaigns')
export default {
  name: 'VTestimonialCampaign',
  components: {
    ModalTestimonialCampaigns
  },
  mixins: [ViewMixinMaster1],
  props: {
    campaignId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    columns: ['author', 'text'],
    form: {},
    isAdd: true,
    attributeModal: 'author',
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        campaign_id: '',
        author: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['testimonialCampaigns', 'pagination', 'applyFilter'])
  },
  watch: {
    campaignId (campaignId) {
      if (campaignId) this.loadTestimonials({ page: this.currentPage, campaignId })
    }
  },
  methods: {
    ...mapActions(['loadTestimonials', 'setModalVisible', 'deleteRecord']),
    addTestimonial () {
      this.form = {
        campaignId: this.campaignId
      }
      this.setModalVisible(true)
    },
    editRecord (data) {
      this.isAdd = false
      this.form = {
        ...data,
        campaignId: this.campaignId
      }
      this.setModalVisible(true)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
